import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
/**
 * Zakladni IconButton wrapnuty Tooltip.
 *
 * @component
 */

function BaseIconButtonWithTooltip(_ref) {
  var icon = _ref.icon,
      iconColor = _ref.iconColor,
      label = _ref.label,
      tooltipPlacement = _ref.tooltipPlacement,
      buttonProps = _objectWithoutProperties(_ref, ["icon", "iconColor", "label", "tooltipPlacement"]);

  return React.createElement(Tooltip, {
    title: label,
    placement: tooltipPlacement
  }, React.createElement("div", null, React.createElement(IconButton, buttonProps, React.cloneElement(icon, {
    color: iconColor
  }))));
}

BaseIconButtonWithTooltip.propTypes = {
  color: PropTypes.oneOf(['default', 'primary', 'secondary', 'inherit']),

  /**
   * Element ikony.
   */
  icon: PropTypes.element.isRequired,
  iconColor: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * Text do tooltipu.
   */
  label: PropTypes.node.isRequired,

  /**
   * Umisteni tooltipu.
   * @placementPropType
   */
  tooltipPlacement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'])
};
BaseIconButtonWithTooltip.defaultProps = {
  color: undefined,
  iconColor: undefined,
  tooltipPlacement: 'bottom'
};
export default BaseIconButtonWithTooltip;